/* eslint-disable jsx-a11y/no-access-key */
import React, { useEffect, useRef, useState } from 'react'
import style from './style.module.sass'
import AiHead from './AiHead'
import TinyEditor from '../TinyEditor'
import Footer from '../Footer/Footer'
import ErrorModal from './ModalWindows/ErrorModal'
import { useTheme } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import { useActions } from '../../utils/action-helper'
import {
  analyseSetAiLocalResult,
  analyseSetAutoTextLanguage,
  analyseSetEnabledBenchmark,
  analyseSetFileName,
  analyseSetLocalResult,
  analyseSetOldText,
  analyseSetResult,
  analyseSetText,
  analyseSetTextLanguage,
  analyseSetTranslatedText,
  analyseSetUseBenchmark,
  batchProcessingClear,
  userGetAllBenchmarks,
  userGetTaskTypes
} from '../../actions'
import TLServiceComponent from '../../contexts/TLServiceComponent'
import { ArrowBack, Check, InsertDriveFile, KeyboardArrowDown, KeyboardArrowUp, Refresh } from '@material-ui/icons'
import {
  checkTextSize,
  convertJSONToObject,
  convertLanguagesToFull,
  convertUTCDateToLocalDate, generateBList,
  handleAISelectionNavigation,
  handlePromptValueToggle,
  isObjectEmpty,
  isObjectsEqual,
  printConvertedDate,
  removeTagMark,
  setLanguage,
  stripHtml,
  textClear,
  wordCount
} from '../../utils'
import TopIndicatorsBarAi from './TopIndicatorsBar/TopIndicatorsBarAI'
import { filterBenchmark, readDNDFiles, startAnalyse } from './analysisFunctions'
import config from '../../config'
import { useTranslation } from 'react-i18next'
import ComponentWithPop from '../common/ComponentWithPop'
import comBotWhite from '../../assets/combot-white.svg'
import Summ from '../../assets/summ-small-without-text.png'
import SummWhite from '../../assets/summ-small-without-text-white.png'
import RoboSpinner from '../RoboSpinner'
import undoBtn from './TextGenerator/assets/undo.png'
import undoBtnWhite from './TextGenerator/assets/undo-white.png'
import undoBtnInactive from './TextGenerator/assets/undo-inactive.png'
import redoBtn from './TextGenerator/assets/redo.png'
import redoBtnWhite from './TextGenerator/assets/redo-white.png'
import redoBtnInactive from './TextGenerator/assets/redo-inactive.png'
import Tonality from './TextGenerator/components/TonalityAi'
import LanaguageLevel from './TextGenerator/components/LangugageLevel'
import Dropzone from 'react-dropzone'
import { FormControl, Input, MenuItem, Select } from '@material-ui/core'
import Close from '@material-ui/icons/Close'
import MainPageWrapper from '../Main-page-wrapper'
import { Redirect } from 'react-router-dom'
import { cancelClick, checkTick, runOurAi } from '../../utils/ai'
import BenchmarkSelector from './BenchmarkSelector'

export default function AiAnalyse () {

  const { t, i18n: { language: i18nLanguage } } = useTranslation()
  const tlService = React.useContext(TLServiceComponent)

  const token = useSelector(state => state.userData.token)

  const useBenchmark = useSelector(state => state.analyseData.useBenchmark)
  const textLanguage = useSelector(state => state.analyseData.textLanguage)
  const benchmarks = useSelector(state => state.userData.benchmarks)
  const taskTypes = useSelector(state => state.userData.taskTypes || [])

  // const aiMode = useSelector(state => state.analyseData.aiMode)
  const enabledBenchmarks = useSelector(state => state.analyseData.enabledBenchmarks)
  const aiMaxTextSize = useSelector((state) => state.userData.user.ai_settings?.max_text_size || {})
  const userRedirects = convertJSONToObject(useSelector((state) => state.userData?.user?.redirect), config.defaultUserRedirects)
  const enabledAIButtons = Object.fromEntries(Object.entries(userRedirects).map(([key, value]) => [key.replace('redirect/', ''), value]))
  const enabledSections = useSelector(state => state.userData.user?.enabled_frontend_sections || [])

  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const isWhite = themeState === config.THEMES_MODES.CONTRAST_LIGHT

  const {
    actionAnalyseSetText,
    actionAnalyseSetOldText,
    actionAnalyseSetTranslatedText,
    aAnalyseSetAiLocalResult,
    aAnalyseSetLocalResult,
    actionAnalyseSetAutoTextLanguage,
    actionAnalyseSetTextLanguage,
    actionAnalyseSetUseBenchmark,
    actionUserGetAllBenchmarks,
    actionAnalyseSetEnabledBenchmark,
    actionBatchProcessingClear,
    actionAnalyseSetFileName,
    actionAnalyseSetResult,
    actionUserGetTaskTypes
  } = useActions({
    actionBatchProcessingClear: batchProcessingClear,
    actionAnalyseSetTranslatedText: analyseSetTranslatedText,
    actionAnalyseSetText: analyseSetText,
    actionAnalyseSetOldText: analyseSetOldText,
    aAnalyseSetLocalResult: analyseSetLocalResult,
    aAnalyseSetAiLocalResult: analyseSetAiLocalResult,
    actionUserGetAllBenchmarks: userGetAllBenchmarks(tlService),
    actionAnalyseSetEnabledBenchmark: analyseSetEnabledBenchmark,
    actionAnalyseSetAutoTextLanguage: analyseSetAutoTextLanguage,
    actionAnalyseSetTextLanguage: analyseSetTextLanguage,
    actionAnalyseSetUseBenchmark: analyseSetUseBenchmark,
    actionAnalyseSetFileName: analyseSetFileName,
    actionAnalyseSetResult: analyseSetResult,
    actionUserGetTaskTypes: userGetTaskTypes(tlService)
  })
  const text = useSelector(state => state.analyseData.text)
  const oldText = useSelector(state => state.analyseData.oldText)
  const reduxCurrentBenchmarkSettings = useSelector(state => state.analyseData.result.benchmark)
  const localResult = useSelector(state => state.analyseData.result.localAnalyseResultData)
  const localResultAI = useSelector(state => state.analyseData.result.aiLocalAnalyseResultData)
  const storageLanguageTextType = convertJSONToObject(
    useSelector(
      (state) => state.userData?.user?.user_options?.analyse_language_texttype
    ),
    config.defaultAnalyseLanguageTextType
  )
  const { theme: { bgColors, colors, borderColors } } = useTheme()
  const [localTranslatedText, setLocalTranslatedText] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [percent, setPercent] = useState(0)

  const taskIdRef = useRef(0)
  const textOriginalRef = useRef('')

  const [error, setError] = useState(null)
  const [enableButtons, setEnableButtons] = useState(false)
  const [enableButtonBack, setEnableButtonBack] = useState(false)
  const [localBenchmark, setLocalBenchmark] = useState(reduxCurrentBenchmarkSettings)
  const [localBenchmarkAI, setLocalBenchmarkAI] = useState({})

  const [summUsageData, setSummUsageData] = useState([])
  const [isSummAiDisabled, setIsSummAiDisabled] = useState(true)

  const [aiSettings, setAiSettings] = useState({})

  const [benchmarkList, setBenchmarkList] = useState([])
  const [useBenchmarkList, setUseBenchmarkList] = useState(0)

  const [editor, setEditor] = useState(null)
  const [aiType, setAiType] = useState(config.AI_TYPE.AI_ASSISTANT)
  const [showOptimization, setShowOptimization] = useState(false)
  const [selectedSetting, setSelectedSetting] = useState({})
  const [promptForOptimization, setPromptForOptimization] = useState('')

  const [promptValues, setPromptValues] = useState({})

  const [redirect, setRedirect] = useState('')
  const aiSelectWrapperRef = useRef(null)
  const benchmarkSelectWrapperRef = useRef(null)

  const aiTypes = {
    Assistant: {
      icon: comBotWhite,
      text: 'ai_assistant'
    },
    Summ: {
      icon: themeState === config.THEMES_MODES.LIGHT ? Summ : SummWhite,
      text: 'ai_summ'
    }
  }

  const undoIcon = themeState === config.THEMES_MODES.CONTRAST_DARK ? undoBtnWhite : undoBtn
  const redoIcon = themeState === config.THEMES_MODES.CONTRAST_DARK ? redoBtnWhite : redoBtn

  const showRefreshButton = localResult['formulaHix'] !== undefined || localResult['formulaFlesch'] !== undefined || localResult['formulaCLIX'] !== undefined
  const fetchSummStatus = async () => {
    if (userRedirects.SummUsage) {
      try {
        const res = await tlService.runRedirect(token, {}, 'SummUsage')
        if (res?.data) {
          setSummUsageData(res.data)
        }
      } catch (e) {
        setError({ text: t('summ_ai_timeout_error'), header: t('summ_ai_header_timeout_error') })
        setPercent(0)
        setSubmitted(false)
        return false
      }
    }
  }

  useEffect(() => {
    if (!taskTypes?.length) {
      actionUserGetTaskTypes(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // create a benchmark list
  useEffect(() => {

    // filter by type
    const filteredTaskTypes = taskTypes.filter(el => el?.function === 'Assistant')

    // if benchmark and taskTypes loaded
    if (!isObjectEmpty(filteredTaskTypes) && !isObjectEmpty(benchmarks)) {
      const [selectedBList, bList] = generateBList(filteredTaskTypes, benchmarks, useBenchmark, 'customPrompt')

      if (bList?.length && selectedBList > -1) {
        const matchedSetting = filteredTaskTypes.find(setting => setting.id === bList[selectedBList].typeId)
        setAiSettings(matchedSetting?.shared_settings?.optimization)
      } else {
        setAiSettings({})
      }

      // set selected position in benchmark list
      setUseBenchmarkList(selectedBList)
      setBenchmarkList(Array.from(bList))

    } else {
      setBenchmarkList([])
      setUseBenchmarkList(0)
      setAiSettings({})
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benchmarks, taskTypes, useBenchmark, i18nLanguage])

  useEffect(() => {
    if (isObjectEmpty(benchmarks)) {
      actionUserGetAllBenchmarks(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!textLanguage) {
      actionAnalyseSetTextLanguage(
        convertLanguagesToFull(i18nLanguage))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textLanguage])

  useEffect(() => {
    //set use benchmark when landing on page:
    if (useBenchmark === 0) {
      if (storageLanguageTextType.textType[textLanguage]) {
        actionAnalyseSetUseBenchmark(storageLanguageTextType.textType[textLanguage])
      } else {
        if (!isObjectEmpty(enabledBenchmarks)) {
          const firstBenchmark = parseInt(Object.keys(enabledBenchmarks)[0])
          actionAnalyseSetUseBenchmark(firstBenchmark)
        } else {
          actionAnalyseSetUseBenchmark(0)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textLanguage])

  useEffect(() => {
    if (!isObjectEmpty(benchmarks)) {
      const filteredBenchmark = filterBenchmark(benchmarks, textLanguage, 'locale_name')
      if (!isObjectsEqual(filteredBenchmark, enabledBenchmarks)) {
        actionAnalyseSetEnabledBenchmark(filteredBenchmark)
      }
    }
    // eslint-disable-next-line
  }, [benchmarks, textLanguage])

  useEffect(() => {

    if (isObjectEmpty(aiSettings)) {
      setSelectedSetting({})
      return
    }
    setSelectedSetting(aiSettings)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [useBenchmark, aiSettings])

  useEffect(() => {
    if (enabledAIButtons?.Summ && enabledSections.includes('ai_summ') && enableButtons) {
      fetchSummStatus()
    }
  }, [enableButtons])

  const regEmpty = /\w/
  useEffect(() => {
    if (isObjectEmpty(enabledBenchmarks) || !regEmpty.test(text)) {
      setEnableButtons(false)
    } else {
      setEnableButtons(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabledBenchmarks, text])

  useEffect(() => {
    if (regEmpty.test(localTranslatedText)) {
      setEnableButtonBack(true)
    } else {
      setEnableButtonBack(false)
    }

  }, [localTranslatedText])

  useEffect(() => {
    if (!isObjectEmpty(summUsageData)) {
      const remainingCharacters = summUsageData.character_limit - summUsageData.character_spent
      const characterExcess = characterCount(text) - remainingCharacters
      const isLicenseExpired = summUsageData.license_end_date ? new Date(summUsageData.license_end_date) < new Date() : false
      setIsSummAiDisabled(characterExcess > 0 || !enableButtons || isLicenseExpired)
    }
  }, [text, summUsageData, enableButtons])

  useEffect(() => {
    document.addEventListener('keydown', e => handleAISelectionNavigation(e,
      aiSelectWrapperRef, benchmarkSelectWrapperRef, config.accessKeys.aiBenchmarkSelection, config.accessKeys.aiTypeSelection))
    return () => document.removeEventListener('keydown', e => handleAISelectionNavigation(e, aiSelectWrapperRef, benchmarkSelectWrapperRef, config.accessKeys.aiBenchmarkSelection, config.accessKeys.aiTypeSelection))
  }, [])


  const localAnalyse = async (clearText, ai = false) => {

    let localUseBenchmark = useBenchmark

    // useBenchmarkList
    if (benchmarkList[useBenchmarkList]) {
      localUseBenchmark = benchmarkList[useBenchmarkList].id
    }

    if (localUseBenchmark === 0) {
      return false
    }

    const checkedSizeError = checkTextSize(config, clearText.length,
      stripHtml(clearText).length)
    if (checkedSizeError) {
      console.log('checkedSizeError error ')
      setError({ text: t(checkedSizeError), header: t(checkedSizeError) })
      return false
    }
    let result
    try {
      result = await startAnalyse(localUseBenchmark, textLanguage, clearText,
        tlService, token, t)
    } catch (e) {
      console.log('error', e)
      return false
    }
    result.error && console.log('result.error ', result.error)
    setError(result.error)
    if (ai) {
      aAnalyseSetAiLocalResult(result.resultData)
      setLocalBenchmarkAI(benchmarks[result.resultTemplate])
    } else {
      aAnalyseSetLocalResult(result.resultData)
      setLocalBenchmark(benchmarks[result.resultTemplate])
      setSubmitted(false)
    }
  }

  const doneTick = async (res) => {
    setLocalTranslatedText(res)

    // run analyses
    setPercent(curr => curr + (100 - curr) / 2)
    await localAnalyse(res, true)
    setPercent(curr => curr + (100 - curr) / 2)
    await localAnalyse(textOriginalRef.current)
    setPromptValues({})
  }

  const errorTick = async (error) => {
    setPromptForOptimization('')
    setPromptValues({})
    setSubmitted(false)
    setError(error)
  }

  const handleOurAi = async (textOriginal, optimization = false) => {
    taskIdRef.current = 0
    setPercent(0)
    setSubmitted(true)
    setError(null)
    const text = textClear(textOriginal)
    textOriginalRef.current = textOriginal

    const [taskId, error] = await runOurAi(
      tlService,
      text,
      token,
      promptValues,
      promptForOptimization,
      benchmarkList,
      useBenchmarkList,
      aiMaxTextSize,
      'Assistant',
      textLanguage,
      optimization)

    if (taskId > 0) {
      taskIdRef.current = taskId
      // set tick
      setTimeout(() => checkTick(t, tlService, taskIdRef, token, setPercent, true, doneTick, errorTick), 1000)
      return true
    }
    setError({ text: t(error.text), header: t(error.header) })
    setPercent(0)
    setSubmitted(false)
    return false
  }

  const handleSumm = async (textOriginal) => {
    setPercent(0)
    setSubmitted(true)
    setError(null)
    textOriginal = textClear(textOriginal)
    let resText
    try {
      const res = await tlService.runRedirect(token, { body: { 'input_text': textOriginal } }, 'Summ')
      if (res?.data?.translated_text) {
        resText = res.data.translated_text.replaceAll(/\n/g, '<br>')
      }
    } catch (e) {
      setError({ text: t('summ_ai_timeout_error'), header: t('summ_ai_header_timeout_error') })
      setPercent(0)
      setSubmitted(false)
      return false
    }
    const arrText = resText.split('\n\n')

    let res = ''
    for (const t of arrText) {
      res += `<p>${t.replaceAll(/\n/g, '<br />')}</p>`
    }

    res = res.replaceAll(/\n/g, '<br>')

    setLocalTranslatedText(res)

    // run analyse
    await localAnalyse(res, true)
    await localAnalyse(text)

    setPercent(0)
    setSubmitted(false)
    return true
  }

  function handleOnLanguageChange (value) {
    actionAnalyseSetTextLanguage(value)
    if (storageLanguageTextType.textType[value]) {
      actionAnalyseSetUseBenchmark(storageLanguageTextType.textType[value])
    } else {
      if (!isObjectEmpty(enabledBenchmarks)) {
        const firstBenchmark = parseInt(Object.keys(enabledBenchmarks)[0])
        actionAnalyseSetUseBenchmark(firstBenchmark)
      } else {
        actionAnalyseSetUseBenchmark(0)
      }
    }
  }

  function setAutoLanguage (text) {
    const lang = setLanguage(text)
    if (lang) {
      actionAnalyseSetAutoTextLanguage(lang)
      if (lang !== textLanguage) {
        handleOnLanguageChange(lang)
      }
    }
  }

  const handleOnEditorChangeFirst = (newText) => {
    newText = newText.replace(/\xAD/g, '')
    actionAnalyseSetText(newText)
    setAutoLanguage(newText)
  }

  const handleOnEditorChangeSecond = (newText) => {
    newText = newText.replace(/\xAD/g, '')
    setLocalTranslatedText(newText)
    console.log('handleOnEditorChangeSecond', newText)
  }

  const handleOnEditorInitFirst = (event) => {
    event.target.setContent(text)
  }

  const handleOnEditorInitSecond = (event, newEditor) => {
    setEditor(newEditor)
  }

  const characterCount = (text) => {
    return textClear(text).length
  }

  const handleAcceptLeftText = () => {

    if (benchmarkList[useBenchmarkList]) {
      actionAnalyseSetUseBenchmark(benchmarkList[useBenchmarkList].id)
      actionAnalyseSetText(text)
      actionAnalyseSetTranslatedText(text)
      actionAnalyseSetResult(localResult, benchmarkList[useBenchmarkList].id, benchmarks[benchmarkList[useBenchmarkList].id])
      setRedirect('/')
    } else {
      actionAnalyseSetText(text)
      actionAnalyseSetTranslatedText(text)
      actionAnalyseSetResult(localResult, useBenchmark, benchmarks[useBenchmark])
      setRedirect('/')
    }
  }

  const handleDiscardText = () => {
    if (oldText?.length) {
      actionAnalyseSetText(oldText)
      actionAnalyseSetTranslatedText(oldText)
    } else {
      actionAnalyseSetText('')
      actionAnalyseSetTranslatedText('')
    }
    setRedirect('/')
  }

  const handleTakeSuggestion = () => {
    if (useBenchmarkList > -1 && benchmarkList[useBenchmarkList]) {
      actionAnalyseSetUseBenchmark(benchmarkList[useBenchmarkList].id)
      actionAnalyseSetText(localTranslatedText)
      actionAnalyseSetOldText(localTranslatedText)
      actionAnalyseSetTranslatedText(localTranslatedText)
      actionAnalyseSetResult(localResultAI, benchmarkList[useBenchmarkList].id, benchmarks[benchmarkList[useBenchmarkList].id])
      setRedirect('/')
    } else {
      actionAnalyseSetText(localTranslatedText)
      actionAnalyseSetOldText(localTranslatedText)
      actionAnalyseSetTranslatedText(localTranslatedText)
      actionAnalyseSetResult(localResultAI, useBenchmark, benchmarks[useBenchmark])
      setRedirect('/')
    }
  }

  const handleSendBack = () => {
    actionAnalyseSetText(localTranslatedText)
    localAnalyse(localTranslatedText)
    localAnalyse(localTranslatedText, true)
  }

  const handleRefreshAnalyseAi = () => {
    localAnalyse(localTranslatedText, true)
  }

  const handleRefreshAnalyse = () => {
    localAnalyse(text)
  }

  const handleOnTextTypeChange = (e) => {
    const newId = parseInt(e.target.value.toString())
    setUseBenchmarkList(newId)

    const filteredTaskTypes = taskTypes.filter(el => el?.function === 'Assistant')
    const matchedSetting = filteredTaskTypes.find(setting => setting.id === benchmarkList[newId].typeId)
    if (!isObjectEmpty(matchedSetting)) {
      setAiSettings(matchedSetting?.shared_settings?.optimization)
    } else {
      setAiSettings({})
    }

    //in-case of changing benchmark, reset the prompts values & reference
    setPromptValues({})

  }

  const summLicenseData = () => {
    let res = ''
    if (!isObjectEmpty(summUsageData)) {
      const remainingCharacters = summUsageData.character_limit - summUsageData.character_spent
      if (remainingCharacters < characterCount(text)) {
        res += `${t('ai_exceeds_characters{{num}}', { num: characterCount(text) - remainingCharacters })}`
      } else {
        res += `${t('ai_remains_characters{{num}}', { num: remainingCharacters })}`
      }
      if (summUsageData.license_active) {
        if (summUsageData.license_end_date) {
          const licence_date = printConvertedDate(convertUTCDateToLocalDate(summUsageData.license_end_date), i18nLanguage)
          if (new Date(summUsageData.license_end_date) > new Date()) {
            res += `${summUsageData.license_end_date ? t('ai_summ_valid_to{{date}}', { date: licence_date }) : ''}`
          } else {
            res += ` ${t('ai_summ_expired{{date}}', { date: licence_date })}`
          }
        }
      } else {
        res += t('ai_summ_inactive_license')
      }
    }
    return res
  }

  function handleUploadFile (acceptedFiles) {
    setSubmitted(true)
    readDNDFiles(token, tlService, acceptedFiles, t).then(async result => {
      setError(result.error)
      const text = result.text.replace(/<a id[^>]+><\/a>/g, '')

      if (enabledSections.indexOf('images_to_text') > -1) {
        // match
        const regexp = /<img[^>]+src="[^>]+base64,([^>]+)"[^>]*>/sg
        let match
        let newText = ''
        let lastPosition = 0
        while ((match = regexp.exec(text)) !== null) {
          try {
            const res = await tlService.runRedirect(token, { 'body': { 'image': match[1] } }, 'ImageToText')
            if (res?.data?.text) {
              newText += text.substring(lastPosition, match.index) + `<img alt="${res.data.text}" title="${res.data.text}" `
                + text.substring(match.index + 4, regexp.lastIndex)
            } else {
              newText += text.substring(lastPosition, regexp.lastIndex)
            }
          } catch (e) {
            console.log('e', e)
            newText += text.substring(lastPosition, regexp.lastIndex)
          }
          lastPosition = regexp.lastIndex
        }
        newText += text.substring(lastPosition)
        const cleanedText = removeTagMark(newText)
        actionAnalyseSetText(cleanedText)
        handleOnEditorChangeFirst(cleanedText, false)
        aAnalyseSetLocalResult({})
        aAnalyseSetAiLocalResult({})
        setLocalTranslatedText('')
      } else {
        const cleanedText = removeTagMark(text)
        actionAnalyseSetText(cleanedText)
        handleOnEditorChangeFirst(cleanedText, false)
        aAnalyseSetLocalResult({})
        aAnalyseSetAiLocalResult({})
        setLocalTranslatedText('')
      }
      setSubmitted(false)
    })
  }

  function handleBatchProcessingUpload (acceptedFiles) {

    actionBatchProcessingClear()

    if (acceptedFiles.length === 0) {
      return
    }

    setSubmitted(true)

    if (acceptedFiles.length === 1 || enabledSections.indexOf('archive') === -1) {
      actionAnalyseSetFileName(acceptedFiles[0]?.name || '')
      handleUploadFile(acceptedFiles)

    }
  }

  const handleCancelClick = async () => {
    await cancelClick(t, tlService, taskIdRef, token, setPercent, setError)
    setPercent(0)
    setSubmitted(false)
  }

  if (redirect) {
    return <Redirect to={redirect}/>
  }

  return (
    <MainPageWrapper>
      <section className={`${style.mainCont} d-flex justify-content-center`}>
        {submitted && <RoboSpinner cancelButton={true} handleCancelClick={handleCancelClick} spinnerProgress={percent}
                                   text={t('ai_spinner_text')}/>}
        <ErrorModal error={error} setError={setError}/>
        <div className={style.mainContEditor} style={{ width: '100%' }}>
          <AiHead handleDiscardText={handleDiscardText}/>
          <div style={{ backgroundColor: bgColors.bgPrimary0, padding: 18 }} className={style.textEditor}>
            {enableButtons && <div className="mb-1 w-100 d-flex position-relative" style={{ width: '100%' }}>
              <div style={{
                position: 'absolute',
                top: 0,
                bottom: !isObjectEmpty(localResult) || !isObjectEmpty(localResultAI) ? '-0.3em' : 0,
                left: '50%',
                width: '1px',
                backgroundColor: '#ccc',
                zIndex: 1
              }}></div>
              <div style={{ width: '50%', paddingRight: '1rem' }}>
                {!isObjectEmpty(localResult) &&
                  <div className="d-flex p-2 flex-wrap position-relative" style={{ width: '100%' }}>
                    <TopIndicatorsBarAi extResultData={localResult} extCurrentBenchmarkSettings={localBenchmark} ai left
                    />

                    {!isObjectEmpty(localResult) &&
                      Object.keys(config.tonalityParameters).filter(v => localResult[v] !== undefined).length > 0 && (
                        <Tonality resultData={localResult} ai tabIndex={config.tabIndexes.aiTonalityWrapperLeft}/>
                      )}

                    {!isObjectEmpty(localResult) && localResult.formulaLanguageLevel > -1 && (
                      <LanaguageLevel resultData={localResult} ai tabIndex={config.tabIndexes.aiLangLevelWrapperLeft}/>
                    )}
                    {showRefreshButton && (
                      <div
                        style={{
                          maxHeight: '2em',
                          marginLeft: '7px',
                          backgroundColor: bgColors.bgPrimary100,
                          borderRadius: '5px',
                          filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.161))',
                        }}
                        className="d-flex align-items-center justify-content-center"
                        onClick={handleRefreshAnalyse}
                        tabIndex={config.tabIndexes.aiRefreshButtonLeft}
                        title={t('accessibility_analysis_refresh')}
                      >
                        <Refresh
                          style={{
                            padding: 5,
                            cursor: 'pointer',
                            color: colors.colorText,
                            fontSize: 30,
                          }}
                        />
                      </div>
                    )}
                    <div className="mb-2" onClick={handleAcceptLeftText}
                         tabIndex={enableButtons ? config.tabIndexes.aiAcceptLeft : -1}
                         style={{ position: 'absolute', right: '0', bottom: '10px', }}
                         accessKey={config.accessKeys.aiAcceptLeft}>
                      <ComponentWithPop text={`${t('ai_accept_text')}`}>
                        <button disabled={!enableButtons} style={{
                          backgroundColor: enableButtons ? bgColors.bgPrimary200 : bgColors.bgPrimary400,
                          padding: 1
                        }} className="d-flex align-items-center px-2 rounded">
                          <Check style={{
                            cursor: enableButtons ? 'pointer' : 'inherit',
                            stroke: enableButtons ? colors.colorProgress100 : bgColors.bgPrimary0,
                            strokeWidth: 2,
                            fontSize: '1.8rem'
                          }}/>
                        </button>
                      </ComponentWithPop>
                    </div>
                  </div>}
              </div>
              <div style={{ width: '50%', paddingLeft: '1rem' }}>
                {!isObjectEmpty(localResultAI) && enableButtonBack &&
                  <div className="d-flex p-2 flex-wrap position-relative" style={{
                    alignSelf: 'flex-end', width: '100%',
                  }}>
                    <TopIndicatorsBarAi extResultData={localResultAI} extCurrentBenchmarkSettings={localBenchmarkAI}
                                        handleRefresh={handleRefreshAnalyseAi} ai
                    />

                    {!isObjectEmpty(localResultAI) &&
                      Object.keys(config.tonalityParameters).filter(v => localResultAI[v] !== undefined).length > 0 && (
                        <Tonality resultData={localResultAI} ai tabIndex={config.tabIndexes.aiTonalityWrapperRight}/>
                      )}

                    {!isObjectEmpty(localResultAI) && localResultAI.formulaLanguageLevel > -1 && (
                      <LanaguageLevel resultData={localResultAI} ai
                                      tabIndex={config.tabIndexes.aiLangLevelWrapperRight}/>
                    )}
                    {showRefreshButton && (
                      <div
                        style={{
                          maxHeight: '2em',
                          marginLeft: '7px',
                          backgroundColor: bgColors.bgPrimary100,
                          borderRadius: '5px',
                          filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.161))',
                        }}
                        className="d-flex align-items-center justify-content-center"
                        onClick={handleRefreshAnalyseAi}
                        tabIndex={config.tabIndexes.aiRefreshButtonRight}
                        title={t('accessibility_analysis_refresh')}
                      >
                        <Refresh
                          style={{
                            padding: 5,
                            cursor: 'pointer',
                            color: colors.colorText,
                            fontSize: 30,
                          }}
                        />
                      </div>
                    )}

                    <div className="mb-2" onClick={handleTakeSuggestion}
                         tabIndex={enableButtonBack ? config.tabIndexes.aiAcceptRight : -1}
                         style={{ position: 'absolute', right: 0, bottom: '10px' }}
                         accessKey={config.accessKeys.aiAcceptRight}>
                      <ComponentWithPop text={`${t('ai_accept_text')}`}>
                        <button disabled={!enableButtonBack} style={{
                          backgroundColor: enableButtonBack ? bgColors.bgPrimary200 : bgColors.bgPrimary400,
                          padding: 1
                        }}
                                className="d-flex align-items-center px-2 rounded">
                          <Check style={{
                            cursor: enableButtonBack ? 'pointer' : 'inherit',
                            stroke: enableButtons ? colors.colorProgress100 : bgColors.bgPrimary0,
                            strokeWidth: 2,
                            fontSize: '1.8rem'
                          }}/>
                        </button>
                      </ComponentWithPop>
                    </div>
                  </div>}

              </div>
            </div>}
            <div className="d-flex align-items-center justify-content-between pl-2 py-2"
                 style={{ border: '1px solid #ccc', padding: '5px', width: '100%', borderBottom: 'none' }}>
              <div
                style={{
                  width: '50%',
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center', gap: '14px',
                }}
              >
                <ComponentWithPop text={`${t('Import-your-word')}`}>
                  <Dropzone onDrop={handleBatchProcessingUpload} multiple={false}>
                    {({ getRootProps, getInputProps }) => (
                      <div
                        {...getRootProps()}
                        style={{
                          marginTop: '6px',
                        }}
                        tabIndex={config.tabIndexes.aiUploadBtn}
                        accessKey={config.accessKeys.aiUploadBtn}
                        aria-label={t('Import-your-word')}
                      >
                        <label
                          onClick={e => e.stopPropagation()}
                          htmlFor="batchProcessingUploadFile"
                          style={{
                            backgroundColor: bgColors.bgPrimary400,
                            borderRadius: '5px',
                            padding: '5px',
                          }}
                        >
                          <InsertDriveFile
                            style={{
                              cursor: 'pointer',
                              width: 25,
                              fill: 'white',
                              marginBottom: '2px',
                              transform: 'scaleX(-1)',
                            }}
                            fontSize="medium"
                          />
                        </label>
                        <input
                          accept=".txt,.docx,.pdf"
                          id="batchProcessingUploadFile"
                          {...getInputProps()}
                        />
                      </div>
                    )}
                  </Dropzone>
                </ComponentWithPop>
                <div ref={aiSelectWrapperRef} title={t('accessibility_ai_select_model')}>
                  <FormControl
                    variant="standard"
                    style={{
                      backgroundColor: bgColors.bgPrimary200,
                      border: 'none',
                      maxHeight: 40,
                      padding: '4px 8px',
                      borderRadius: '5px',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                    tabIndex={config.tabIndexes.aiSelectAi}
                  >
                    <Select
                      disableUnderline
                      IconComponent={props => (
                        <KeyboardArrowDown {...props} style={{ color: colors.colorIcons }}/>
                      )}
                      className="font-weight-bold"
                      style={{ color: colors.colorText }}
                      value={aiType}
                      onChange={(e) => setAiType(e.target.value)}
                      inputProps={{
                        style: {
                          color: colors.colorMutedText,
                          fontWeight: 'bold',
                          fontSize: '0.875rem',
                        },
                      }}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            backgroundColor: bgColors.bgPrimary200,
                            color: colors.colorText,
                          },
                        },
                      }}
                    >
                      {Object.entries(aiTypes).map(([key, value]) => (
                        <MenuItem key={key} value={value.text} style={{ display: 'flex', alignItems: 'center' }}>
                          <span>{t(value.text)}</span>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="d-flex align-items-center justify-content-between" ref={benchmarkSelectWrapperRef}>
                  {aiType === config.AI_TYPE.AI_ASSISTANT &&
                    <>
                      <span className="mr-2" style={{ color: colors.colorText }}>{t('ai_select_text-type')}:</span>
                      <FormControl
                        variant="outlined"
                        style={{
                          backgroundColor: bgColors.bgPrimary200,
                          border: 'none',
                          height: 40,
                          borderRadius: '5px',
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          maxWidth: '15rem',
                        }}
                        tabIndex={config.tabIndexes.aiTextType}
                      >
                        <BenchmarkSelector
                          benchmarkList={benchmarkList}
                          useBenchmarkList={useBenchmarkList}
                          handleOnTextTypeChange={handleOnTextTypeChange}
                          accessKey={config.accessKeys.benchmarkSelectionTop}
                        styleMain={{
                          color: colors.colorText,
                          fontSize: '0.875rem',
                          height: '100%',
                          fontWeight: 'bold',
                        }}
                          stylePaper={{
                            backgroundColor: bgColors.bgPrimary200,
                            color: colors.colorText,
                          }}
                          styleArrow={{ color: colors.colorIcons }}
                        />
                      </FormControl>
                    </>
                  }
                </div>
              </div>
              {!isObjectEmpty(aiSettings) && aiType === config.AI_TYPE.AI_ASSISTANT &&
                <div style={{ width: '50%', display: 'flex', justifyContent: 'flex-end' }}
                     onClick={() => setShowOptimization(!showOptimization)}
                     tabIndex={config.tabIndexes.aiShowOptimization} accessKey={config.accessKeys.aiShowOptimization}
                     title={t('accessibility_ai_show_optimization_button')}>
                  <button
                    style={{
                      backgroundColor: showOptimization ? bgColors.bgPrimary500 : bgColors.bgPrimary200,
                      border: 'none',
                      padding: '4px 8px',
                      borderRadius: '5px',
                      display: 'flex',
                      height: 40,
                      alignItems: 'center',
                      cursor: 'pointer',
                      marginLeft: '10px',
                      color: isWhite ? colors.colorText : showOptimization ? colors.colorBtnText : colors.colorMutedText,
                    }}
                    className={`font-weight-bold`}
                  >
                    <span style={{ marginRight: 8 }}>{t('ai_show_optimization')}</span>
                    {showOptimization ? (
                      <KeyboardArrowUp
                        style={{ color: isWhite ? colors.colorText : colors.colorBtnText, fontSize: '1.5rem' }}/>
                    ) : (
                      <KeyboardArrowDown style={{ color: colors.colorPrimary300, fontSize: '1.5rem' }}/>
                    )}
                  </button>
                </div>}
            </div>
            <div className="d-flex justify-content-between" style={{
              border: '1px solid #ccc', overflow: 'hidden', width: '100%', position: 'relative', height: '100%',
            }}>
              <div style={{ display: 'table-cell', width: showOptimization ? '50%' : '49%', position: 'relative' }}>
                {showOptimization ?
                  <div className="p-3 pb-5" style={{
                    backgroundColor: bgColors.bgPrimary200,
                    height: '100%',
                    maxHeight: '700px',
                    overflowY: 'auto'
                  }}>
                    <div onClick={() => setShowOptimization(false)} style={{
                      backgroundColor: bgColors.bgPrimary900,
                      cursor: 'pointer',
                      float: 'right',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: 1
                    }}>
                      <Close style={{ fontSize: '.75rem', color: colors.colorWhite }}/>
                    </div>
                    <div>
                      <label className="font-weight-bold small m-0"
                             style={{ color: colors.colorText }}>{t('ai_prompt')}</label>
                      <FormControl fullWidth style={{
                        flex: 1,
                        borderBottom: '1px solid #ccc',
                        backgroundColor: bgColors.bgBoxes,
                        borderRadius: '7px',
                        padding: '0 10px',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                      }}>
                        <Input
                          placeholder={t('ai_optimization-placeholder')}
                          multiline
                          rows="4"
                          value={promptForOptimization}
                          onChange={(e) => {
                            setPromptForOptimization(e.target.value)
                          }}
                          tabIndex={config.tabIndexes.aiOptInput}
                          inputProps={{
                            accessKey: config.accessKeys.aiOptInput,
                            style: {
                              color: colors.colorText,
                              fontSize: '0.875rem',
                              fontWeight: 'bold',
                            },
                          }}
                          disableUnderline
                        />
                      </FormControl>
                      <hr className="my-4" style={{ borderTop: '1px solid #d4d3d3' }}/>
                    </div>

                    <div className="row">
                      {!isObjectEmpty(selectedSetting?.settings) && selectedSetting.settings.map((setting, settIndex) => (
                        <div className="col-12 mb-2" key={setting.name}>
                          <label className="font-weight-bold small d-block mb-2"
                                 style={{ color: colors.colorText }}>{t(setting.name)}</label>
                          <div className="d-flex flex-wrap" style={{ gap: '0.5rem' }}>
                            {setting.values.map((value, valIndex) => {
                              const isSelected = promptValues[setting.name] === value.id
                              const flatIndex = selectedSetting.settings
                                .slice(0, settIndex)
                                .reduce((acc, s) => acc + s.values.length, 0) + valIndex
                              return (
                                <div onClick={() => setPromptValues(prev => handlePromptValueToggle(prev, setting.name, value.id))}
                                     tabIndex={config.tabIndexes.aiSelections[flatIndex] ?? -1}>
                                  <button key={value.id} type="button"
                                          className={`btn px-2 py-1 ${isSelected ? colors.colorWhite : colors.colorMutedText}`}
                                          style={{
                                            backgroundColor: isSelected ? bgColors.bgAiBtnSelected : bgColors.bgAiBtn,
                                            fontSize: '0.75rem',
                                            transition: 'background-color 0.2s ease, color 0.2s ease',
                                            boxShadow: 'none',
                                            color: isSelected ? colors.colorWhite : isWhite ? colors.colorWhite : isContrast ? colors.colorText : colors.colorMutedText,
                                            border: isSelected ? `1px solid ${borderColors.borderPrimary200}` : 'none'
                                          }}
                                          onMouseEnter={(e) => {
                                            if (!isSelected) {
                                              e.currentTarget.style.backgroundColor = bgColors.bgAiBtnHover
                                              e.currentTarget.style.setProperty('color', colors.colorWhite, 'important')
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            if (!isSelected) {
                                              e.currentTarget.style.backgroundColor = bgColors.bgAiBtn
                                              e.currentTarget.style.setProperty('color', isWhite
                                                ? colors.colorWhite
                                                : isContrast
                                                  ? colors.colorText
                                                  : colors.colorMutedText, 'important')
                                            }
                                          }}>
                                    {t(value.text)}
                                  </button>
                                </div>

                              )
                            })}
                          </div>
                        </div>
                      ))}
                    </div>
                    <hr className="my-4 pb-2" style={{ borderTop: '1px solid #d4d3d3' }}/>
                    <div className="w-100 d-flex justify-content-center align-items-center">
                      <button onClick={() => { handleOurAi(localTranslatedText, true) }} className="btn"
                        title={t('ai_optimization_button')} style={{
                          backgroundColor: bgColors.bgProgress100,
                          color: colors.colorBtnText,
                          border: isContrast ? `1px solid ${borderColors.borderPrimary200}` : 'none',
                          boxShadow: 'none'
                      }} accessKey={config.accessKeys.runAnalyse} tabIndex={config.tabIndexes.aiOptBtn}>
                        {t('ai_optimization_button')}
                      </button>
                    </div>
                  </div>
                  :
                  <div>
                    <div style={{
                      borderBottom: '1px solid #ccc', paddingBottom: '10px', marginBottom: '10px', borderRadius: '8px'
                    }}>
                      <TinyEditor
                        initialValue=""
                        text={text}
                        editorId="first"
                        handleOnSelectorChange={() => { }}
                        handleOnEditorKeyUp={() => { }}
                        handleOnEditorInit={handleOnEditorInitFirst}
                        handleOnEditorChange={handleOnEditorChangeFirst}
                        handleOnMouseOver={() => { }}
                        handleOnMouseClick={() => { }}
                        fromAI
                        bordered={false}
                        shortcutKey={config.accessKeys.editor.toLowerCase()}
                      />
                    </div>
                    <div className="d-flex justify-content-between mt-2 mb-2">
                      <div className="d-flex justify-content-between align-items-center">
                        <div title={t('accessibility_word_count')} className="ml-3"
                             style={{ color: colors.colorMutedText }}><span>{t('Words')}:</span>
                          <b>{wordCount(text) || 0}</b></div>
                      </div>
                      {enabledAIButtons?.Assistant && enabledSections.includes('ai_assistant') && aiType === config.AI_TYPE.AI_ASSISTANT &&
                        <div
                          tabIndex={config.tabIndexes.aiRunBtn}
                          style={{ display: 'flex', justifyContent: 'flex-end' }}
                        >
                          <button disabled={!enableButtons}
                                  className="btn d-flex align-items-center justify-content-center"
                                  title={t('ai_variant_erstelle')} style={{
                            backgroundColor: bgColors.bgProgress100,
                            color: colors.colorBtnText,
                            border: `1px solid ${borderColors.borderPrimary200}`
                          }} onClick={() => { handleOurAi(text) }} accessKey={config.accessKeys.runAnalyse}>
                            <img style={{ marginRight: 4 }} src={aiTypes.Assistant.icon} alt="" width="30px"/>
                            {t('ai_variant_erstelle')}
                          </button>
                        </div>}
                      {enabledAIButtons?.Summ && enabledSections.includes('ai_summ') && aiType === config.AI_TYPE.AI_SUMM &&
                        <div
                          onClick={() => { handleSumm(text) }}
                          tabIndex={config.tabIndexes.aiRunBtn}
                          accessKey={config.accessKeys.runAnalyse}
                          style={{ display: 'flex', justifyContent: 'flex-end' }}
                        ><ComponentWithPop html={true} text={`${t('start-summ-ai')} ${summLicenseData()}`}>
                          <button disabled={isSummAiDisabled}
                                  className="btn d-flex align-items-center justify-content-center"
                                  title={t('ai_summ_erstelle')} style={{
                            backgroundColor: bgColors.bgProgress100,
                            color: colors.colorBtnText,
                            border: `1px solid ${borderColors.borderPrimary200}`
                          }}>
                            <img style={{ marginRight: 4 }} src={aiTypes.Summ.icon} alt="" width="25px"/>
                            {t('ai_summ_erstelle')}
                          </button>
                        </ComponentWithPop>
                        </div>}
                    </div>
                  </div>
                }

              </div>
              <div style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: '50%',
                width: '1px',
                backgroundColor: '#ccc',
                zIndex: 1
              }}></div>
              <div style={{ display: 'table-cell', width: '49%', position: 'relative' }}>
                <div style={{
                  borderBottom: '1px solid #ccc', paddingBottom: '10px', marginBottom: '10px', borderRadius: '8px'
                }}>
                  <TinyEditor
                    initialValue=""
                    text={localTranslatedText}
                    editorId="second"
                    handleOnSelectorChange={() => { }}
                    handleOnEditorKeyUp={() => { }}
                    handleOnEditorInit={handleOnEditorInitSecond}
                    handleOnEditorChange={handleOnEditorChangeSecond}
                    handleOnMouseOver={() => { }}
                    handleOnMouseClick={() => { }}
                    tabIndex={-1}
                    fromAI
                    bordered={false}
                    shortcutKey={config.accessKeys.editorSecond.toLowerCase()}
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center mt-2 mb-2 mr-3">
                  <div className="ml-1 d-flex justify-content-between align-items-center">
                    <ComponentWithPop text={`${t('start-send-text-back')}`}>
                      <button style={{
                        borderRadius: '5px',
                        padding: '2px 5px',
                        marginRight: '15px',
                        filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.161))',
                        backgroundColor: bgColors.bgPlainBtn,
                        width: 'fit-content',
                      }}
                              onMouseEnter={(e => {
                                  e.currentTarget.style.backgroundColor = bgColors.bgPrimary200
                                }
                              )}
                              onMouseLeave={(e => {
                                  e.currentTarget.style.backgroundColor = bgColors.bgPlainBtn
                                }
                              )}
                              onClick={handleSendBack}
                              disabled={!enableButtonBack}
                              accessKey={config.accessKeys.aiSwitchText}
                              tabIndex={enableButtonBack ? config.tabIndexes.aiSwitchText : -1}
                              aria-label={t('ai_send_back')}
                      >
                        <ArrowBack
                          style={{
                            cursor: enableButtonBack ? 'pointer' : 'inherit',
                            color: enableButtonBack ? colors.colorText : colors.colorMutedText,
                          }}
                          fontSize="large"
                          alt={t('ai_send_back')}
                        />

                      </button>
                    </ComponentWithPop>
                    <div title={t('accessibility_word_count')} style={{ color: colors.colorMutedText }}>
                      <span>{t('Words')}:</span> <b>{wordCount(localTranslatedText) || 0}</b></div>
                  </div>
                  <div style={{
                    borderRadius: '5px',
                    padding: '5px 10px',
                    filter: 'drop-shadow(0 0 3px rgba(0, 0, 0, 0.161))',
                    backgroundColor: bgColors.bgPlainBtn,
                  }}>
                    <img
                      style={{
                        cursor: 'pointer',
                        marginRight: 10,
                        width: 20,
                        height: 25
                      }}
                      onClick={() => {
                        if (editor) {
                          editor.undoManager.undo()
                        }
                      }}
                      title={t('accessibility_analysis_undo')}
                      src={editor?.undoManager?.hasUndo() ? undoIcon : undoBtnInactive}
                      alt="undo"
                    />
                    <span style={{ borderLeft: '1px solid #817d7d', height: '30px', marginRight: 10 }}></span>
                    <img
                      style={{
                        cursor: 'pointer',
                        marginRight: 10,
                        width: 20,
                        height: 25,
                      }}
                      onClick={() => {
                        if (editor) {
                          editor.undoManager.redo()
                        }
                      }}
                      title={t('accessibility_analysis_redo')}
                      src={editor?.undoManager?.hasRedo() ? redoIcon : redoBtnInactive}
                      alt="redo"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>
          <Footer/>
        </div>
      </section>
    </MainPageWrapper>
  )
}